import React, { useEffect } from 'react'
import * as Yup from "yup";
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Box, makeStyles, Button, LinearProgress } from '@material-ui/core'

import { actionTypes } from './../../../redux/oms/customer_select_get_kyc_profile';
import { actionTypes as actionTypesNotif } from './../../../redux/notificationAlert';


let useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        minHeight: 270,
        minWidth: 450,
        backgroundColor: "white",
        padding: 15,
        borderRadius: 8,
        [theme.breakpoints.down("700")]: {
            minWidth: '100% !important',
        },
    },
    gridBtns: {
        direction: 'rtl',
        marginTop: 15,
        [theme.breakpoints.down("500")]: {
            minWidth: '100% !important',
            display: 'flex',
            flexDirection: 'column-reverse',
            flexWrap: 'wrap'
        },
    },
    btnOtlineBlack: {
        fontSize: 14,
        backgroundColor: "white",
        color: "black",
        margin: "0 5px",
        padding: '9px 20px',
        border: `1px solid black`,
        [theme.breakpoints.down("1236")]: {
            padding: '9px 7px',
        },
        '&:hover': {
            backgroundColor: "black",
            color: "white"
        },
        [theme.breakpoints.down("500")]: {
            minWidth: '100% !important',
            width:'100%',
            margin:0,
            marginBottom: '10px'
        },
    },
    openAccountRed: {
        backgroundColor: theme.palette.light.type2,
        color: "white",
        margin: "0 5px",
        padding: '9px 20px',
        border: `1px solid ${theme.palette.light.type2}`,
        fontSize: 14,
        [theme.breakpoints.down("1236")]: {
            padding: '9px 7px',
        },
        '&:hover': {
            backgroundColor: "#ffffff",
            color: theme.palette.light.type2,
            border: `1px solid ${theme.palette.light.type2}`,
        },
        [theme.breakpoints.down("500")]: {
            minWidth: '100% !important',
            width:'100%',
            margin:0
        },
    },
    TextField: {
        minWidth: '350px',
        [theme.breakpoints.down("500")]: {
            minWidth: '100% !important',
        },
    },
    loading: {
        width: "99%",
        margin: "auto",
        top: "4px",
        zIndex: 2,
    },
}))


export default function Index({ setIndexChild, state, open, textError, setOpen, setflagApi }) {

    const classes = useStyles()
    const dispatch = useDispatch()

    const reducerProfile = useSelector(state => state.reducer_customer_get_kyc_profile)

    useEffect(() => {
        if (reducerProfile?.isOk) {
            setIndexChild(2)
        }
    }, [reducerProfile?.isOk])//eslint-disable-line react-hooks/exhaustive-deps 


    let initialValues = {
        otp: ''
    }

    useEffect(() => {
        if (!open) {
            setTimeout(() => {
                setIndexChild(0)
            }, 600);
        }
    }, [open])//eslint-disable-line react-hooks/exhaustive-deps 

    const validateShcama = Yup.object().shape({
        otp:
            Yup.string()
                .required(),
    });


    let onSubmit = (values, { setSubmitting }) => {

        if(!state?.national_id){
         alert('کد ملی کاربر خالی می باشد')
            return
        } 
        let _data = {
            national_id: state.national_id,
            otp: values.otp
        }


        dispatch({ type: actionTypes.clubmemberCustomerKycProfileSelectAsync, payload: _data })
    }



    return (
        <>
                    {
                reducerProfile?.loading && (
                    <LinearProgress className={classes['loading']} />
                )
            }
        
       
        <div className={classes['root']}>
            <div>
                <h3>
                دریافت اطلاعات از سامانه سجام
                </h3>
            </div>
            <hr />
            <div>
                <p>
                لطفا «کد تایید» پیامک شده را وارد کنید
                </p>
            </div>
            <div>
                <Formik
                    initialValues={{ ...initialValues }}
                    validationSchema={validateShcama}
                    onSubmit={onSubmit} >
                    {
                        ({
                            values,
                            touched,
                            errors,
                            handleSubmit,
                            setFieldValue,
                        }
                        ) => (
                            <div className={''}>
                                {/* <div>
                                    <p>
                                        کد تایید دریافت شده از سامانه سجام:
                                    </p>
                                </div> */}
                                <div>

                                    <form onSubmit={handleSubmit}>
                                        <Box width="100%">
                                            <TextField
                                                id="outlined-name"
                                         
                                                value={values.otp}
                                                onChange={event => setFieldValue('otp', event.target.value)}
                                                margin="normal"
                                                variant="outlined"
                                                style={{ width: "50%" }}
                                                className={classes['TextField']}
                                                placeholder='کد تایید'
                                            />
                                            {
                                                touched.otp && errors.otp && (
                                                    <div className={'text-danger'}>
                                                        {/* {textError} */}
                                                        لطفا کد تایید را وارد کنید
                                                    </div>
                                                )
                                            }
                                        </Box>
                                        {/* <Box>
                                            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                                                <button className={'btnsBlue'} type="submit">ثبت درخواست</button>
                                                <button className={'btnsRed'} onClick={() => setOpen(false)}>لغو</button>
                                            </Box>
                                        </Box> */}
                                        <div className={classes['gridBtns']}>
                                            <Button className={classes.openAccountRed} onClick={() => setOpen(false)}>
                                                لغو
                                            </Button>
                                            <Button className={classes.btnOtlineBlack}
                                                onClick={() => handleSubmit()}
                                            >
                                                ثبت درخواست
                                            </Button>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        )
                    }
                </Formik>
            </div>
        </div>
        </>
    )
}
